export enum InternalRoleTypes {
  Admin = 'ddna-studio-admin',
}

export enum OrganizationRoleTypes {
  Editor = 'editor',
  Owner = 'owner',
  Support = 'support',
  Analytics = 'analytics',
}

export enum OrganizationRoleDescriptions {
  Editor = 'Can see and edit only their own projects',
  Owner = 'Can access and edit all projects in their organization and manage members',
  Support = 'Can access and edit all projects in their organization and manage members',
  Analytics = 'Can access Insights for all projects in their organization. Cannot edit projects.',
}
